import { Component } from '@angular/core';

/** Keeps /policies/:slug on the home screen without a second page. */
@Component({
  selector: 'app-policy-route',
  standalone: true,
  template: '',
})
export class PolicyRouteComponent {}
